var map = {
	"./RiceSampleKTB.jpg": 9353,
	"./RiceSampleKTB.png": 7169,
	"./almonds.jpg": 9911,
	"./arabian dates.jpg": 1420,
	"./banner1.png": 804,
	"./banner2.png": 9711,
	"./banner3.png": 694,
	"./banner_2.png": 7922,
	"./black-raisins.avif": 1886,
	"./cashew.jpg": 3186,
	"./chudidar 2.jpeg": 8582,
	"./chudidar 3.jpeg": 8797,
	"./chudidar1.jpeg": 9051,
	"./dates.avif": 8106,
	"./deal1.png": 7916,
	"./deal1_1.png": 940,
	"./deal1_2.png": 999,
	"./deal1_3.png": 2686,
	"./deal2.png": 5495,
	"./deal2_1.png": 1931,
	"./deal2_2.png": 4368,
	"./deal2_3.png": 8569,
	"./deal3.png": 2350,
	"./deal4.png": 833,
	"./deal5.png": 9704,
	"./deal6.png": 5315,
	"./deal7.png": 3402,
	"./deal8.png": 525,
	"./deal9.png": 3044,
	"./dried-apricots-raisin-nuts.jpg": 3899,
	"./dried-figs.jpg": 8427,
	"./fried-assorted mix.avif": 7991,
	"./ikall k525 pro (4899).webp": 7913,
	"./itel a49.jpg": 4827,
	"./itel vision2s.jpg": 8382,
	"./jean black.webp": 6274,
	"./jean cargo.webp": 513,
	"./jean pack 4.webp": 3938,
	"./jeans-shirt.jpg": 6081,
	"./kiwi-dried.jpg": 3808,
	"./lava z3pro.jpg": 2239,
	"./lava z70(4949).webp": 2091,
	"./micromax in 2b.jpg": 3318,
	"./micromax-bharat-4.webp": 4993,
	"./no_image.png": 6724,
	"./nokia c 20 plus.jpg": 4808,
	"./nokia g21.webp": 3307,
	"./raisins.avif": 4708,
	"./raw-walnuts.jpg": 6134,
	"./samsung galaxy a03s.jpg": 7506,
	"./stack-jeans.jpg": 7745,
	"./top kurti 2.webp": 5445,
	"./top kurti.webp": 659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;